import { createAsyncThunk } from '@reduxjs/toolkit';
import { getEppTerminalTypes } from 'application/components/api/EppTerminalType';
import { selectComponentState } from 'projectRedux/store';

export const fetchAsyncEppTerminalTypes = createAsyncThunk(
  'components/fetchAsyncEppTerminalType',
  async (data: {}, thunkAPI) => {
    const response = await getEppTerminalTypes();
    return response;
  },
  {
    condition(arg, thunkAPI) {
      return selectComponentState(thunkAPI.getState()).eppTerminalTypes.loading === 'init';
    },
  }
);
